import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const Invoice = () => {

    const [bill, setBill] = useState(null)

    // useEffect(()=>{
    //     axios.post("https://dealersonly.parts/beta/api/admin/sendInvoice", {
    //       user:'hey@gutsche.agency',
    //       month:'january',
    //       year:'2023'
    //     })
    //       .then(res => {
    //         setBill(res.data)
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       })
    //   },[])

      const generatePDF = () => {
        // Create a new jsPDF instance
        jsPDF.autoTableSetDefaults({
          headStyles: { fillColor: 0 },
        })
        const doc = new jsPDF();
        var totalPagesExp = '{total_pages_count_string}'

        var pageSize = doc.internal.pageSize
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

        doc.setFontSize(11)
        doc.setTextColor(100)

        var absender = doc.splitTextToSize("Rasi Bajazid\nAbu Jo Trading\nMusterstraße 38\n12345 Musterstadt", pageWidth - 35, {})
        doc.text(absender, pageWidth - 45, 15)

        var anschrift = doc.splitTextToSize("Max Mustermann\nBikeshop24\nMusterstraße 38\n12345 Musterstadt", pageWidth - 35, {})
        doc.text(anschrift, 14, 40)

        doc.setFontSize(18)
        doc.text('Abrechnung Monat', 14, 75)
        doc.setFontSize(11)
        doc.setTextColor(100)

        
        
        var text = doc.splitTextToSize("Sehr geehrter Herr Mustermann,\nfür den den Zeitraum Januar erlaube ich mir, für die Nutzung der Platform, folgende Kosten in Rechnung zu stellen.", pageWidth - 35, {})
        doc.text(text, 14, 85)

        // Define the table headers and data
        const headers = [['Pos.', 'Artikel', 'Kategorie', 'Gebühr', 'Summe']];
        const data = [
          ['1', 'langer Artikelname mit Text', '555-1234', '5,00€', '60,00€'],
          ['2', 'Artikel', '555-1234', '5,00€', '60,00€'],
          ['3', 'Artikel', '555-1234', '5,00€', '60,00€'],
        ];
    
        // Add the table to the PDF document
        doc.autoTable({
          head: headers,
          body: data,
          startY: 105,
          horizontalPageBreak: true,
          didDrawPage: function (data) {            
      
            // Footer
            var str = 'Seite ' + doc.internal.getNumberOfPages()
            // Total page number plugin only available in jspdf v1.0+
            if (typeof doc.putTotalPages === 'function') {
              str = str + ' von ' + totalPagesExp
            }
            doc.setFontSize(10)
      
            // jsPDF 1.4+ uses getWidth, <1.4 uses .width
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            doc.text('Rasi Bajazid - Deutsche Bank - DE12 3456 7890 0000 0000 01 - Verwendungszweck: Ihr Name', data.settings.margin.left, pageHeight - 20)
            doc.text(str, (pageSize.width/2) - data.settings.margin.left, pageHeight - 10)
          },
        });

        var pageSize = doc.internal.pageSize
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

        doc.setFontSize(13)
        doc.setTextColor(0)
        var gesamt = doc.splitTextToSize("Zwischensumme: 600,00€\n19% MwSt.: 60,00€\nGesamt: 660,00€", pageWidth - 35, {})
        doc.text(gesamt, 14, doc.lastAutoTable.finalY + 10)
        doc.setFontSize(11)
        doc.setTextColor(100)
        var text = doc.splitTextToSize("Bitte zahlen Sie den offenen Betrag innerhalb der nächsten 14 Tage, an unten stehendes Konto mit der Angabe Ihres Namens im Verwendungszweck.", pageWidth - 35, {})
        doc.text(text, 14, doc.lastAutoTable.finalY + 30)

        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPagesExp)
        }
    
        // Save the PDF file
        doc.save('rechnung.pdf');
      };

      const sendInvoice = async() => {

        try{
          await axios.post("https://dealersonly.parts/beta/api/admin/sendInvoice",{
            userEmail:'hey@gutsche.agency',
            month:'februar',
            year:'2023'
          })
          .then(res => {
              console.log(res)
          })}catch(error){
  
          }

      }
      

  return (
    <div>
      <button onClick={sendInvoice}>Generate PDF</button>
    </div>
  )
}

export default Invoice

